import { Text } from 'styles/themeColors';
import { capitalize, formatDateTime } from '../../../utils/formatters';
import { LegacyColumn as Column } from 'components/MaterialTable/MatDataGridTypes';

export const CommissionColumnUS: Column<any> = {
  title: 'Commission % US (Avg.)',
  field: 'avgCommissionUS',
  headerStyle: { color: Text.primary },
  cellStyle: { padding: '8px 12px' },
  width: '140px',
  render: (rowData: any) => rowData.avgCommissionUS != null ? `${rowData.avgCommissionUS}%` : 'N/A',
};

export const CommissionColumnCA: Column<any> = {
  title: 'Commission % CA (Avg.)',
  field: 'avgCommissionCA',
  headerStyle: { color: Text.primary },
  cellStyle: { padding: '8px 12px' },
  width: '140px',
  render: (rowData: any) => rowData.avgCommissionCA != null ? `${rowData.avgCommissionCA}%` : 'N/A',
};

const ProductColumns: Column<any>[] = [
  {
    title: 'Image',
    field: 'imagePath',
    width: '50px',
    sorting: false,
    align: 'left',
    cellStyle: { padding: '4px 8px', textOverflow: 'clip', overflow: 'visible' },
  },
  {
    title: 'Status',
    field: 'status',
    headerStyle: { color: Text.primary },
    cellStyle: { textTransform: 'capitalize', padding: '8px 12px' },
    width: '90px !important',
    render: (rowData: any) => capitalize(rowData.status),
  },
  {
    title: 'Name',
    field: 'name',
    headerStyle: { color: Text.primary },
    removable: false,
    width: '220px',
    cellStyle: { padding: '8px 12px' },
  },
  {
    title: 'Brands',
    field: 'brand',
    headerStyle: { color: Text.primary },
    cellStyle: { padding: '8px 12px' },
    width: '100px',
  },
  {
    title: 'Inventory',
    field: 'inventory',
    headerStyle: { color: Text.primary },
    cellStyle: { padding: '8px 12px' },
    width: '100px',
  },
  {
    title: 'Variants',
    field: 'variantsCount',
    headerStyle: { color: Text.primary },
    cellStyle: { padding: '8px 12px' },
    width: '80px',
  },
  {
    title: 'Warehouses',
    field: 'warehousesCount',
    headerStyle: { color: Text.primary },
    cellStyle: { padding: '8px 12px' },
    width: '110px',
  },
  {
    title: 'Category',
    field: 'category',
    headerStyle: { color: Text.primary },
    cellStyle: { padding: '8px 12px' },
    width: '140px',
  },
  {
    title: 'Publish Date',
    field: 'publishedOn',
    type: 'datetime',
    headerStyle: { color: Text.primary },
    render: (rowData: any) =>
      rowData.publishedOn ? formatDateTime(rowData.publishedOn, true) : 'N/A',
    cellStyle: { padding: '8px 12px' },
    width: '120px',
  },
  {
    title: 'Actions',
    field: 'actions',
    removable: false,
    cellStyle: { padding: '8px 12px' },
    headerStyle: { color: '#FFF' },
    sorting: false,
    width: '100px'
  }
];

export default ProductColumns;
